import axios from 'axios';

// export const digestDocument = fileId =>
//   axios.get(`/ess/api/sign/${fileId}/deferred-hash`);
export const digestDocument = fileId =>
  axios.post('/ess/api/sign/deferred-hash', {
    fileID: fileId
  });

export const batchDigestDocument = fileIds =>
  axios.post(`/ess/api/sign/batch-deferred-hash-file-id`,{files:fileIds});

  export const getDummyDigest = () =>
  axios.get(`/ess/api/sign/dummy-deferred-hash`);


export const digestBAFormDocument = fileId =>
  axios.post(`/ess/api/sign/deferred-hash/ba-form`, {
    file: { FileID: fileId }
  });

export const digestNonPdfDocument = fileId =>
  axios.post(`/ess/api/sign/non-pdf-hash`, { FileID: fileId });

export const digestNormalPdfDocument = fileId =>
  axios.post(`/ess/api/sign/normal-pdf-hash`, { FileID: fileId });  

export const mergeSignature = (digest, signature, cert) =>
  axios.post(`/api/sign/merge-signed-deferred-hash`, {
    digest,
    signature,
    cert
  });

export const mergeNonPdfSignature = (fileId, signature, cert) =>
  axios.post(`/api/sign/non-pdf/create-sign-record`, {
    fileId,
    signature,
    cert
  });
  
export const mergeNormalPdfSignature = (fileId, signature, cert) =>
  axios.post(`/api/sign/normal-pdf/create-sign-record`, {
    fileId,
    signature,
    cert
  });

export const batchMergeSignature = files =>
  axios.post(`/api/sign/batch-merge-signed-deferred-hash`, files);

export const essBatchMergeSignature = files =>
  axios.post(`/ess/api/sign/batch-merge-signed-deferred-hash`, files);

export const getSigningClientDownloadPath = () => axios.get(`/api/systemsetting/module/0ceb612e-77bc-4b0e-9cd9-c02ef891fba7/public?keys=SignClientVersion&keys=SignClientURL`);

export const loginWithECert = body =>
  axios.post(`/ess/api/sign/user/login`,body)

  export const registorWithECert = body =>
  axios.post(`/ess/api/sign/user/registration`,body)